var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-list"},[_c('error-boundary',[_c('app-user-item')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }